import { FC, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

/** Rotas em que o convidado anônimo da sala pode manter a sessão Firebase. */
export function isMeetingRoomPath(pathname: string): boolean {
  return (
    pathname.startsWith("/sala/") ||
    pathname.startsWith("/salax/") ||
    pathname.startsWith("/sala-beta/")
  );
}

/**
 * Convidado (Anonymous Auth) só vale dentro da sala.
 * Fora dela, encerra a sessão para não bloquear compra / parecer logado no site.
 */
const ClearAnonymousGuestOutsideRoom: FC = () => {
  const location = useLocation();
  const { isLoading, isAnonymousGuest, logout } = useAuth();
  const signingOutRef = useRef(false);

  useEffect(() => {
    if (isLoading || !isAnonymousGuest) {
      signingOutRef.current = false;
      return;
    }

    if (isMeetingRoomPath(location.pathname)) {
      signingOutRef.current = false;
      return;
    }

    if (signingOutRef.current) return;
    signingOutRef.current = true;

    void logout().finally(() => {
      signingOutRef.current = false;
    });
  }, [isLoading, isAnonymousGuest, location.pathname, logout]);

  return null;
};

export default ClearAnonymousGuestOutsideRoom;
